import { Redirect, Route, Switch } from 'react-router-dom'
import ConnectChargepointPage from './chargepoint'
import ChargePointAuthenticatePage from './chargepoint/authenticate'
import { BehindFlag } from '@/app/components'
import SelectChargerDevicePage from './select'
import ConnectChargerValuePropPage from './value-prop'
import BrandNotFoundPage from './not-found'
import { useIsAvaBasePath } from '@/app/hooks/ava/useAvaVerification'
import { match } from 'ts-pattern'

export default function ConnectChargerRoutes() {
  const isAva = useIsAvaBasePath()

  const basePath = match({ isAva })
    .with({ isAva: true }, () => `/ava/onboarding/connect-device/charger`)
    .with({ isAva: false }, () => `/connect-device/charger`)
    .exhaustive()
  return (
    <BehindFlag flag="connect_charger" experimental>
      <Switch>
        <Route exact path={`${basePath}/value-prop`}>
          <ConnectChargerValuePropPage />
        </Route>
        <Route exact path={`${basePath}/select`}>
          <SelectChargerDevicePage />
        </Route>
        <Route exact path={`${basePath}/not-found`}>
          <BrandNotFoundPage />
        </Route>
        <Route exact path={`${basePath}/chargepoint`}>
          <ConnectChargepointPage />
        </Route>
        <Route path={`${basePath}/chargepoint/authenticate`}>
          <ChargePointAuthenticatePage />
        </Route>
        <Route path={'*'}>
          <Redirect to={`${basePath}/value-prop`} />
        </Route>
      </Switch>
    </BehindFlag>
  )
}
